import { QueryOptions, useQuery } from "react-query";
import { Order } from "../@types";
import { API_URL, APIError, APIResponse, get } from "../api";

function useOrders(options?: QueryOptions<APIResponse<Order[]>, APIError>) {
  const {
    isLoading,
    isError,
    data: orders,
    isRefetching,
    refetch,
  } = useQuery<APIResponse<Order[]>, APIError>(
    "orders",
    () =>
      get(API_URL + "/commerce/orders", {
        byPassStatus: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    {
      refetchInterval: false,
      ...options,
    }
  );

  return {
    orders: orders?.data,
    isError,
    isLoading,
    isRefetching,
    refreshOrders: refetch,
  };
}

export default useOrders;
